"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6888],{

/***/ 577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ Pill; }
/* harmony export */ });
/* unused harmony export StyledPillar */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);
/* harmony import */ var qualification_hooks_useBreakpoints__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19916);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-flex;\n  flex-wrap: nowrap;\n  border: none;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: ",
        ";\n  gap: ",
        "px;\n  background: #f0f0f0;\n  border-radius: 66px;\n  white-space: nowrap;\n  line-height: 170%;\n  transition: color 0.2s, background-color 0.2s;\n\n  :enabled {\n    cursor: pointer;\n\n    :hover,\n    :active,\n    :focus {\n      background-color: ",
        ";\n      color: white;\n    }\n  }\n\n  ",
        " {\n    padding: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Pill = function(param) {
    var children = param.children, onClick = param.onClick, id = param.id, size = param.size;
    var mobile = (0,qualification_hooks_useBreakpoints__WEBPACK_IMPORTED_MODULE_4__/* .useBreakpointDown */ .a)("xs");
    var isSmall = size === "sm" || mobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPillar, {
        $size: size || "md",
        id: id,
        type: "button",
        disabled: !onClick,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Typography, {
            component: "div",
            variant: "caption",
            lineHeight: "170%",
            fontSize: isSmall ? 10 : 12,
            children: children
        })
    });
};
var StyledPillar = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].button(_templateObject(), function(props) {
    return props.$size === "sm" ? props.theme.spacing(0.5, 1) : props.theme.spacing(1, 2);
}, function(props) {
    return props.theme.spacing(0.5);
}, function(props) {
    return props.theme.palette.grey.secondary;
}, function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(0.5, 1);
});


/***/ }),

/***/ 82179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var qualification_components_PillLabel_Pill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(577);
/* harmony import */ var qualification_components_PillLabel_usePillValue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93771);
/* harmony import */ var qualification_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85643);
/* harmony import */ var qualification_context_model__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91538);






function PillLabel(param) {
    var stepId = param.stepId, questionId = param.questionId, text = param.text, size = param.size;
    var value = (0,qualification_components_PillLabel_usePillValue__WEBPACK_IMPORTED_MODULE_3__/* .usePillValue */ .L)({
        stepId: stepId,
        questionId: questionId
    });
    var ref = (0,qualification_context__WEBPACK_IMPORTED_MODULE_4__/* .useQualification */ ._8)(), actions = ref.actions, state = ref.state;
    var step = state.status === "answering" && state.qualification.steps.find(function(_step) {
        return _step.id === stepId;
    });
    var isPillClickable = Boolean(state.status === qualification_context_model__WEBPACK_IMPORTED_MODULE_5__/* .QUALIFICATION_STATUS.answering */ .w.answering && step && !(step === null || step === void 0 ? void 0 : step.disabled));
    var onClick = isPillClickable ? function() {
        return actions.setQuestion(stepId);
    } : undefined;
    if (!value) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(qualification_components_PillLabel_Pill__WEBPACK_IMPORTED_MODULE_2__/* .Pill */ .D, {
        size: size,
        onClick: onClick,
        children: text
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PillLabel);


/***/ }),

/***/ 93771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ usePillValues; },
/* harmony export */   "L": function() { return /* binding */ usePillValue; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26793);
/* harmony import */ var qualification_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85643);
/* harmony import */ var qualification_schema_questions_cateringCategoriesQuestion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61535);
/* harmony import */ var qualification_schema_questions_cityQuestion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26407);
/* harmony import */ var qualification_schema_questions_leadTypeQuestion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62798);
/* harmony import */ var shared_helpers_dates__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47004);







var usePillValue = function(param) {
    var stepId = param.stepId, questionId = param.questionId;
    var state = (0,qualification_context__WEBPACK_IMPORTED_MODULE_1__/* .useQualification */ ._8)().state;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)().locale;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)("qualification").t;
    if (!("qualification" in state)) {
        return null;
    }
    return getPillValue({
        steps: state.qualification.steps,
        answers: state.qualification.answers,
        t: t,
        locale: locale,
        stepId: stepId,
        questionId: questionId
    });
};
var usePillValues = function(options) {
    var state = (0,qualification_context__WEBPACK_IMPORTED_MODULE_1__/* .useQualification */ ._8)().state;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)().locale;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)("qualification").t;
    if (!("qualification" in state)) {
        return [];
    }
    var pillValues = options.map(function(param) {
        var questionId = param.stepId, childQuestionId = param.questionId;
        return getPillValue({
            steps: state.qualification.steps,
            answers: state.qualification.answers,
            t: t,
            locale: locale,
            stepId: questionId,
            questionId: childQuestionId
        });
    }).flat().filter(function(truthy) {
        return !!truthy;
    });
    return pillValues;
};
function getPillValue(param) {
    var t = param.t, steps = param.steps, answers = param.answers, locale = param.locale, stepId = param.stepId, questionId = param.questionId;
    var step = steps.find(function(q) {
        return q.id === stepId;
    });
    if (!step) {
        return null;
    }
    switch(step.id){
        case "city":
            {
                var answer = answers === null || answers === void 0 ? void 0 : answers.city;
                var item = qualification_schema_questions_cityQuestion__WEBPACK_IMPORTED_MODULE_3__/* .CITY_QUESTION_ITEMS.find */ .fF.find(function(leadTypeItem) {
                    return leadTypeItem.value === answer;
                });
                return item ? {
                    stepId: stepId,
                    text: getItemLabel(locale, item)
                } : null;
            }
        case "catering_categories":
            {
                var ref;
                var items = (answers === null || answers === void 0 ? void 0 : (ref = answers.catering_categories) === null || ref === void 0 ? void 0 : ref.map(function(category) {
                    return qualification_schema_questions_cateringCategoriesQuestion__WEBPACK_IMPORTED_MODULE_2__/* .CATERING_CATEGORY_ITEMS.find */ .sF.find(function(i) {
                        return i.value === category;
                    });
                }).filter(function(v) {
                    return !!v;
                })) || [];
                return items.map(function(item) {
                    return {
                        stepId: stepId,
                        questionId: questionId,
                        text: getItemLabel(locale, item)
                    };
                });
            }
        case "event_date":
            {
                var ref1 = [
                    answers.event_date,
                    answers.lead_type
                ], date = ref1[0], leadType = ref1[1];
                var leadTypeItem = qualification_schema_questions_leadTypeQuestion__WEBPACK_IMPORTED_MODULE_4__/* .LEAD_TYPE_ITEMS.find */ .__.find(function(leadTypeItem) {
                    return leadTypeItem.value === leadType;
                });
                var returnValue = [
                    {
                        stepId: stepId,
                        text: (0,shared_helpers_dates__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p6)(date, locale) || ""
                    }, 
                ];
                if (leadTypeItem) {
                    returnValue.push({
                        stepId: step.id,
                        text: getItemLabel(locale, leadTypeItem)
                    });
                }
                return returnValue;
            }
        case "people_count_and_budget":
            {
                var ref2 = [
                    answers.caterer_minimum_order_value,
                    answers.price_per_person,
                    answers.min_order_number, 
                ], total = ref2[0], pricePerPerson = ref2[1], peopleCount = ref2[2];
                return [
                    {
                        stepId: stepId,
                        text: t("qualification:selection.people", {
                            amount: peopleCount
                        })
                    },
                    {
                        stepId: stepId,
                        text: t("qualification:selection.budget", {
                            perPerson: pricePerPerson,
                            total: total
                        })
                    }, 
                ];
            }
        case "dietary_restrictions":
            {
                if (questionId === "number_of_carnivore") {
                    return {
                        stepId: stepId,
                        questionId: questionId,
                        text: t("qualification:selection.carnivore", {
                            amount: answers.number_of_carnivore
                        })
                    };
                }
                if (questionId === "number_of_vegans") {
                    return {
                        stepId: stepId,
                        questionId: questionId,
                        text: t("qualification:selection.vegan", {
                            amount: answers.number_of_vegans
                        })
                    };
                }
                if (questionId === "number_of_vegetarians") {
                    return {
                        stepId: stepId,
                        questionId: questionId,
                        text: t("qualification:selection.vegetarian", {
                            amount: answers.number_of_vegetarians
                        })
                    };
                }
                return null;
            }
        default:
            {
                return null;
            }
    }
}
function getItemLabel(locale, item) {
    if (locale === "de") {
        return item.labelDe;
    }
    return item.labelEn;
}


/***/ }),

/***/ 8464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ question_types_BudgetQuestionWithPeopleCount; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./src/qualification/context/index.tsx + 11 modules
var context = __webpack_require__(85643);
// EXTERNAL MODULE: ./src/qualification/context/model.ts
var model = __webpack_require__(91538);
// EXTERNAL MODULE: ./src/qualification/schema/questions/index.ts
var questions = __webpack_require__(89121);
// EXTERNAL MODULE: ./src/system/components/QuantityStepperField.tsx
var QuantityStepperField = __webpack_require__(84561);
;// CONCATENATED MODULE: ./src/qualification/components/question_types/BudgetQuestionWithPeopleCount/PeopleCountStepper.tsx






function PeopleCountStepper() {
    var ref = (0,context/* useQualification */._8)(), actions = ref.actions, state = ref.state, answerOf = ref.answerOf, errorsOf = ref.errorsOf;
    if (state.status !== model/* QUALIFICATION_STATUS.answering */.w.answering) {
        return null;
    }
    var answer = answerOf(questions/* questions.peopleCount.id */.X.peopleCount.id);
    var errors = errorsOf(questions/* questions.peopleCount.id */.X.peopleCount.id);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityStepperField/* default */.ZP, {
        name: questions/* questions.peopleCount.id */.X.peopleCount.id,
        id: questions/* questions.peopleCount.id */.X.peopleCount.id,
        value: answer || 0,
        error: !!(errors === null || errors === void 0 ? void 0 : errors.length),
        onChange: function(value) {
            return actions.answerQuestion(questions/* questions.peopleCount.id */.X.peopleCount.id, value);
        }
    });
}
/* harmony default export */ var BudgetQuestionWithPeopleCount_PeopleCountStepper = (PeopleCountStepper);

// EXTERNAL MODULE: ./src/qualification/schema/questions/peopleCountQuestion.ts
var peopleCountQuestion = __webpack_require__(65231);
// EXTERNAL MODULE: ./src/shared/hooks/useLocalizedFieldName.js
var useLocalizedFieldName = __webpack_require__(25734);
;// CONCATENATED MODULE: ./src/qualification/components/question_types/BudgetQuestionWithPeopleCount/PopularValues.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        "px;\n  justify-content: space-around;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px dotted #000;\n  cursor: pointer;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







function PopularValues() {
    var actions = (0,context/* useQualification */._8)().actions;
    var localizedAttributeName = (0,useLocalizedFieldName/* default */.Z)().localizedAttributeName;
    var localizedOptions = (0,react.useMemo)(function() {
        var ref;
        return (ref = peopleCountQuestion/* peopleCountQuestion.suggestions */.m.suggestions) === null || ref === void 0 ? void 0 : ref.map(function(option) {
            return {
                value: option.value,
                // @ts-expect-error TODO: type this function
                label: option[localizedAttributeName("label")]
            };
        });
    }, []) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBox, {
        flexWrap: "wrap",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        id: peopleCountQuestion/* peopleCountQuestion.id */.m.id,
        children: localizedOptions.map(function(option, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                onClick: function() {
                    return actions.answerQuestion(peopleCountQuestion/* peopleCountQuestion.id */.m.id, option.value);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTypography, {
                    variant: "caption",
                    children: option.label
                })
            }, "".concat(option.value, "::").concat(index));
        })
    });
}
/* harmony default export */ var BudgetQuestionWithPeopleCount_PopularValues = (PopularValues);
var FlexBox = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(1.5);
});
var StyledTypography = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject1());

// EXTERNAL MODULE: ./src/qualification/hooks/useCurrentUser.ts + 1 modules
var useCurrentUser = __webpack_require__(866);
// EXTERNAL MODULE: ./src/qualification/schema/questions/budgetQuestion.ts
var budgetQuestion = __webpack_require__(92789);
// EXTERNAL MODULE: ./src/system/components/ButtonGroupSelect/PriceStepperField.tsx
var PriceStepperField = __webpack_require__(87733);
;// CONCATENATED MODULE: ./src/qualification/components/question_types/BudgetQuestionWithPeopleCount/index.tsx

function BudgetQuestionWithPeopleCount_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-column: 1 / 3;\n"
    ]);
    BudgetQuestionWithPeopleCount_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BudgetQuestionWithPeopleCount_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #e86202;\n  font-weight: 500;\n"
    ]);
    BudgetQuestionWithPeopleCount_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 2px;\n  background-color: ",
        ";\n  width: 100%;\n  grid-column: 1 / 3;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  max-width: 441px;\n  margin-left: auto;\n  align-items: center;\n  margin-right: auto;\n\n  ",
        " {\n    display: grid;\n    grid-template-columns: 1fr auto;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












function BudgetQuestionWithPeopleCount() {
    var ref, ref1;
    var ref2 = (0,context/* useQualification */._8)(), answerOf = ref2.answerOf, errorsOf = ref2.errorsOf, actions = ref2.actions;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var currentUserAccount = (0,useCurrentUser/* default */.Z)().currentUserAccount;
    var isManagedAccount = currentUserAccount === null || currentUserAccount === void 0 ? void 0 : (ref = currentUserAccount.owner) === null || ref === void 0 ? void 0 : (ref1 = ref.salesforceCustomer) === null || ref1 === void 0 ? void 0 : ref1.isManagedAccount;
    var pricePerPersonAnswer = answerOf(budgetQuestion/* pricePerPersonQuestion.id */.fk.id);
    var pricePerPersonErrors = errorsOf(budgetQuestion/* pricePerPersonQuestion.id */.fk.id);
    var budgetAnswer = answerOf(budgetQuestion/* totalBudgetQuestion.id */.JL.id);
    var budgetErrors = errorsOf(budgetQuestion/* totalBudgetQuestion.id */.JL.id);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                mb: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                    as: "label",
                    htmlFor: questions/* questions.peopleCount.id */.X.peopleCount.id,
                    children: t("common:questions.min_order_number")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                mb: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BudgetQuestionWithPeopleCount_PeopleCountStepper, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullRowBox, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BudgetQuestionWithPeopleCount_PopularValues, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {
                my: 4
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                mb: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                    as: "label",
                    htmlFor: budgetQuestion/* pricePerPersonQuestion.id */.fk.id,
                    children: t("common:questions.budgetProPerson")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                mb: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceStepperField/* default */.ZP, {
                    name: budgetQuestion/* pricePerPersonQuestion.id */.fk.id,
                    id: budgetQuestion/* pricePerPersonQuestion.id */.fk.id,
                    min: 0,
                    autoFocus: false,
                    error: !!(pricePerPersonErrors === null || pricePerPersonErrors === void 0 ? void 0 : pricePerPersonErrors.length),
                    value: pricePerPersonAnswer ? Math.round(pricePerPersonAnswer) : 0,
                    onChange: function(val) {
                        actions.answerQuestion(budgetQuestion/* pricePerPersonQuestion.id */.fk.id, val, {
                            isManagedAccount: isManagedAccount
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                mb: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                    as: "label",
                    htmlFor: budgetQuestion/* totalBudgetQuestion.id */.JL.id,
                    children: t("common:questions.totalBudget")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceStepperField/* default */.ZP, {
                name: budgetQuestion/* totalBudgetQuestion.id */.JL.id,
                id: budgetQuestion/* totalBudgetQuestion.id */.JL.id,
                min: 0,
                autoFocus: false,
                error: !!(budgetErrors === null || budgetErrors === void 0 ? void 0 : budgetErrors.length),
                value: budgetAnswer ? Math.floor(budgetAnswer) : 0,
                onChange: function(val) {
                    return actions.answerQuestion(budgetQuestion/* totalBudgetQuestion.id */.JL.id, Math.floor(val), {
                        isManagedAccount: isManagedAccount
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullRowBox, {
                mt: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorWrapper, {
                    children: pricePerPersonErrors[0] || budgetErrors[0]
                })
            })
        ]
    });
}
var FullRowBox = (0,styled_components_browser_esm["default"])(esm.Box)(BudgetQuestionWithPeopleCount_templateObject());
var ErrorWrapper = styled_components_browser_esm["default"].div(BudgetQuestionWithPeopleCount_templateObject1());
var Divider = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.palette.grey[100];
});
var Wrapper = styled_components_browser_esm["default"].div(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
});
/* harmony default export */ var question_types_BudgetQuestionWithPeopleCount = (BudgetQuestionWithPeopleCount);


/***/ }),

/***/ 53466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57833);
/* harmony import */ var react_day_picker_dist_style_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19034);
/* harmony import */ var react_day_picker_dist_style_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_day_picker_dist_style_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var qualification_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85643);
/* harmony import */ var qualification_context_model__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91538);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-left: auto;\n  margin-right: auto;\n  flex-direction: row;\n  row-gap: 2rem;\n  align-items: center;\n  column-gap: 0rem;\n\n  ",
        " {\n    column-gap: 2rem;\n  }\n\n  ",
        " {\n    align-items: stretch;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







function DatePickerLayout(_param) {
    var hasSidebar = _param.hasSidebar, dateSelector = _param.dateSelector, sideContent = _param.sideContent, boxProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "hasSidebar",
        "dateSelector",
        "sideContent"
    ]);
    var ref = (0,qualification_context__WEBPACK_IMPORTED_MODULE_5__/* .useQualification */ ._8)(), actions = ref.actions, state = ref.state, answerOf = ref.answerOf;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (answerOf("lead_type") === undefined) actions.answerQuestion("lead_type", "private");
    }, [
        answerOf
    ]);
    if (state.status !== qualification_context_model__WEBPACK_IMPORTED_MODULE_6__/* .QUALIFICATION_STATUS.answering */ .w.answering) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        $hasSidebar: hasSidebar
    }, boxProps), {
        children: [
            dateSelector,
            sideContent
        ]
    }));
}
var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__["default"])(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box)(_templateObject(), function(param) {
    var theme = param.theme, $hasSidebar = param.$hasSidebar;
    return theme.breakpoints.up($hasSidebar ? "lg" : "md");
}, function(param) {
    var theme = param.theme, $hasSidebar = param.$hasSidebar;
    return theme.breakpoints.up($hasSidebar ? "md" : "sm");
});
/* harmony default export */ __webpack_exports__["Z"] = (DatePickerLayout);


/***/ }),

/***/ 23922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DatePicker_DatePickerSide; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(30553);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Info.js
var Info = __webpack_require__(70089);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./node_modules/react-day-picker/dist/style.css
var style = __webpack_require__(19034);
// EXTERNAL MODULE: ./src/qualification/context/index.tsx + 11 modules
var context = __webpack_require__(85643);
// EXTERNAL MODULE: ./src/qualification/context/model.ts
var model = __webpack_require__(91538);
// EXTERNAL MODULE: ./src/qualification/hooks/useCurrentUser.ts + 1 modules
var useCurrentUser = __webpack_require__(866);
// EXTERNAL MODULE: ./src/qualification/schema/questions/index.ts
var questions = __webpack_require__(89121);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
;// CONCATENATED MODULE: ./src/system/components/AppSwitch.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: inline-block;\n  width: 28px;\n  height: 14px;\n  border-radius: 100px;\n  flex-shrink: 0;\n\n  input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n    border-radius: 34px;\n  }\n\n  span {\n    position: absolute;\n    border-radius: 100px;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    -webkit-transition: 0.3s;\n    transition: 0.3s;\n\n    &:before {\n      position: absolute;\n      content: '';\n      height: 10px;\n      width: 10px;\n      left: 2px;\n      bottom: 2px;\n      border-radius: 50%;\n      background-color: white;\n      -webkit-transition: 0.3s;\n      transition: 0.3s;\n    }\n  }\n\n  input:checked + span {\n    background-color: ",
        ";\n  }\n\n  input:checked + span:before {\n    -webkit-transform: translateX(14px);\n    -ms-transform: translateX(14px);\n    transform: translateX(14px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var AppSwitch = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwitchLabelWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                type: "checkbox"
            }, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
        ]
    });
};
var SwitchLabelWrapper = styled_components_browser_esm["default"].label(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.secondary.light;
});
/* harmony default export */ var components_AppSwitch = (AppSwitch);

;// CONCATENATED MODULE: ./src/qualification/components/question_types/DatePicker/DatePickerSide.tsx

function DatePickerSide_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n"
    ]);
    DatePickerSide_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  max-width: 340px;\n  flex-direction: column;\n  background-color: #f8f8f8;\n  border-radius: 0.5rem;\n  padding: 2rem;\n  padding-left: 2.5rem;\n  padding-right: 0.5rem;\n  gap: 1rem;\n  text-align: left;\n\n  ",
        " {\n    max-width: 320px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













function DatePickerSide() {
    var _leadType, ref;
    var t = (0,useTranslation/* useTranslation */.$)("qualification").t;
    var ref1 = (0,context/* useQualification */._8)(), actions = ref1.actions, state = ref1.state, answerOf = ref1.answerOf;
    var theme = (0,useTheme/* default */.Z)();
    var currentUserAccount = (0,useCurrentUser/* default */.Z)().currentUserAccount;
    var isLoggedIn = !!currentUserAccount;
    var showLeadTypeCheckbox = (ref = (_leadType = questions/* questions.leadType */.X.leadType).condition) === null || ref === void 0 ? void 0 : ref.call(_leadType, isLoggedIn);
    (0,react.useEffect)(function() {
        if (answerOf("lead_type") === undefined) actions.answerQuestion("lead_type", "private");
    }, [
        answerOf
    ]);
    if (state.status !== model/* QUALIFICATION_STATUS.answering */.w.answering) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwitchesWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AppSwitch, {
                    name: "multi-days",
                    checked: answerOf("is_multi_day"),
                    onChange: function(value) {
                        return actions.answerQuestion("is_multi_day", value.target.checked);
                    }
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelTypography, {
                            variant: "body2",
                            ml: 1.5,
                            mr: 2,
                            pt: 0.25,
                            pl: 1,
                            children: t("questionTypes.multiDaySwitch.label")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                            title: t("questionTypes.multiDaySwitch.infoTooltip"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                color: theme.palette.grey[600],
                                display: "flex",
                                alignItems: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                    color: "inherit"
                                })
                            })
                        })
                    ]
                })
            }),
            showLeadTypeCheckbox && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                mt: "auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AppSwitch, {
                        name: "lead-type",
                        checked: answerOf("lead_type") === "business",
                        onChange: function(value) {
                            return actions.answerQuestion("lead_type", value.target.checked ? "business" : "private");
                        }
                    }),
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelTypography, {
                        variant: "body2",
                        ml: 1.5,
                        pt: 0.25,
                        pl: 1,
                        children: t("questionTypes.leadType.switch")
                    })
                })
            })
        ]
    });
}
var LabelTypography = (0,styled_components_browser_esm["default"])(esm.Typography)(DatePickerSide_templateObject());
var SwitchesWrapper = styled_components_browser_esm["default"].div(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
/* harmony default export */ var DatePicker_DatePickerSide = (DatePickerSide);


/***/ }),

/***/ 68106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ question_types_DietaryDistribution; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./src/qualification/components/question_types/DietaryStepper.tsx
var DietaryStepper = __webpack_require__(39979);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
;// CONCATENATED MODULE: ./src/qualification/components/question_types/DietaryTotal.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: grid;\n  justify-items: center;\n  grid-template-columns: 1fr 1fr;\n\n  ",
        " {\n    display: flex;\n    justify-content: center;\n    gap: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function DietaryTotal(param) {
    var count = param.count;
    var t = (0,useTranslation/* useTranslation */.$)("qualification").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
        mt: 3,
        mb: 5,
        display: "flex",
        width: "100%",
        justifyContent: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridWrapper, {
            container: true,
            spacing: 2,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                    variant: "body1",
                    fontWeight: 600,
                    children: t("diet.pax")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                    variant: "body1",
                    children: count
                })
            ]
        })
    });
}
var GridWrapper = (0,styled_components_browser_esm["default"])(Grid/* default */.Z)(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.down("xs");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
/* harmony default export */ var question_types_DietaryTotal = (DietaryTotal);

// EXTERNAL MODULE: ./src/qualification/context/index.tsx + 11 modules
var context = __webpack_require__(85643);
// EXTERNAL MODULE: ./src/qualification/context/model.ts
var model = __webpack_require__(91538);
// EXTERNAL MODULE: ./src/qualification/schema/steps/index.ts
var steps = __webpack_require__(82546);
;// CONCATENATED MODULE: ./src/qualification/components/question_types/DietaryDistribution.tsx

function DietaryDistribution_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    DietaryDistribution_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var step = steps/* SCHEMA_STEPS.dietary_restrictions */.C$.dietary_restrictions;
function DietaryDistribution() {
    var ref = (0,context/* useQualification */._8)(), state = ref.state, answerOf = ref.answerOf;
    if (state.status !== model/* QUALIFICATION_STATUS.answering */.w.answering) {
        return null;
    }
    var peopleCountAnswer = answerOf("min_order_number");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
        maxWidth: "500px",
        width: "100%",
        mx: "auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
                children: step.questions.map(function(childQuestion, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DietaryStepper/* default */.Z, {
                        autoFocus: index === 0,
                        question: childQuestion
                    }, childQuestion.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(question_types_DietaryTotal, {
                count: peopleCountAnswer || 0
            })
        ]
    });
}
var Wrapper = styled_components_browser_esm["default"].div(DietaryDistribution_templateObject());
/* harmony default export */ var question_types_DietaryDistribution = (DietaryDistribution);


/***/ }),

/***/ 39979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57833);
/* harmony import */ var qualification_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85643);
/* harmony import */ var qualification_context_model__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91538);
/* harmony import */ var qualification_schema_steps__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82546);
/* harmony import */ var shared_hooks_useLocalizedFieldName__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25734);
/* harmony import */ var system_components_QuantityStepperField__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(84561);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  justify-items: center;\n  grid-template-columns: 1fr 1fr;\n  justify-content: center;\n  gap: ",
        "px;\n\n  ",
        " {\n    grid-template-columns: 1fr;\n    gap: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var ICON_SIZE_IN_PX = 30;
var step = qualification_schema_steps__WEBPACK_IMPORTED_MODULE_7__/* .SCHEMA_STEPS.dietary_restrictions */ .C$.dietary_restrictions;
// eslint-disable-next-line react/display-name
var DietaryStepper = function(param) {
    var question = param.question, autoFocus = param.autoFocus;
    var localizedAttributeName = (0,shared_hooks_useLocalizedFieldName__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().localizedAttributeName;
    var ref = (0,qualification_context__WEBPACK_IMPORTED_MODULE_5__/* .useQualification */ ._8)(), state = ref.state, actions = ref.actions, answerOf = ref.answerOf;
    var localizedOptions = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var ref;
        return {
            image: question === null || question === void 0 ? void 0 : (ref = question.content) === null || ref === void 0 ? void 0 : ref.image,
            //@ts-expect-error TODO: type the function
            label: question.content[localizedAttributeName("title")]
        };
    }, [
        question.content
    ]);
    if (state.status !== qualification_context_model__WEBPACK_IMPORTED_MODULE_6__/* .QUALIFICATION_STATUS.answering */ .w.answering) {
        return null;
    }
    var answer = answerOf(question.id);
    var handleChange = function(value) {
        actions.answerQuestion(question.id, value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
        my: 2,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(GridWrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
                    display: "flex",
                    ml: {
                        xs: "-".concat(ICON_SIZE_IN_PX, "px"),
                        sm: 0
                    },
                    justifySelf: {
                        xs: "center",
                        sm: "start"
                    },
                    alignItems: "center",
                    justifyContent: {
                        xs: "center",
                        sm: "start"
                    },
                    children: [
                        (localizedOptions === null || localizedOptions === void 0 ? void 0 : localizedOptions.image) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                            alt: "",
                            src: localizedOptions === null || localizedOptions === void 0 ? void 0 : localizedOptions.image,
                            width: ICON_SIZE_IN_PX,
                            height: ICON_SIZE_IN_PX
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Typography, {
                            variant: "body1",
                            pl: 1,
                            children: localizedOptions.label
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(system_components_QuantityStepperField__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        autoFocus: autoFocus,
                        name: question.id,
                        id: question.id,
                        value: answer,
                        onChange: handleChange
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DietaryStepper);
var GridWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.down("xs");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});


/***/ }),

/***/ 45078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ useAnswerPills; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/qualification/components/PillLabel/usePillValue.ts
var usePillValue = __webpack_require__(93771);
;// CONCATENATED MODULE: ./src/qualification/components/selectionSchema.tsx
var selectionSchema = [
    {
        stepId: "city"
    },
    {
        stepId: "catering_categories"
    },
    {
        stepId: "event_date"
    },
    {
        stepId: "people_count_and_budget"
    },
    {
        stepId: "dietary_restrictions",
        questionId: "number_of_vegetarians"
    },
    {
        stepId: "dietary_restrictions",
        questionId: "number_of_vegans"
    },
    {
        stepId: "dietary_restrictions",
        questionId: "number_of_carnivore"
    }, 
];

// EXTERNAL MODULE: ./src/qualification/context/index.tsx + 11 modules
var context = __webpack_require__(85643);
// EXTERNAL MODULE: ./src/qualification/context/model.ts
var model = __webpack_require__(91538);
;// CONCATENATED MODULE: ./src/qualification/hooks/useAnswerPills.ts







function useAnswerPills(param) {
    var display = param.display;
    var state = (0,context/* useQualification */._8)().state;
    var pills = (0,react.useMemo)(function() {
        if (state.status !== model/* QUALIFICATION_STATUS.answering */.w.answering && state.status !== model/* QUALIFICATION_STATUS.answered */.w.answered && state.status !== model/* QUALIFICATION_STATUS.qualifiedForRequest */.w.qualifiedForRequest) {
            return [];
        }
        var orderedSelectionSchema = selectionSchema.map(function(schemaItem) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, schemaItem), {
                stepPosition: state.qualification.steps.findIndex(function(step) {
                    return step.id === schemaItem.stepId;
                })
            });
        });
        orderedSelectionSchema.sort(function(a, b) {
            return a.stepPosition - b.stepPosition;
        });
        if (display === "previous-answers" && state.status === model/* QUALIFICATION_STATUS.answering */.w.answering) {
            var currentStep = state.qualification.step;
            var currentStepIndex = state.qualification.steps.findIndex(function(step) {
                return step.id === currentStep.id;
            });
            var previousStepIds = state.qualification.steps.slice(0, currentStepIndex).map(function(step) {
                return step.id;
            });
            return orderedSelectionSchema.filter(function(answer) {
                return previousStepIds.includes(answer.stepId);
            });
        }
        return orderedSelectionSchema;
    }, [
        display,
        state
    ]);
    var pillValues = (0,usePillValue/* usePillValues */.D)(pills);
    return pillValues;
}


/***/ }),

/***/ 35269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CustomerTier_CustomerTier; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/lib/ablyft/index.ts
var ablyft = __webpack_require__(49423);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/RadioGroup.js + 1 modules
var RadioGroup = __webpack_require__(37661);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Radio/Radio.js + 4 modules
var Radio = __webpack_require__(32340);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(30553);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/PersonOutline.js
var PersonOutline = __webpack_require__(73279);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/StarBorder.js
var StarBorder = __webpack_require__(1944);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/SentimentSatisfied.js
var SentimentSatisfied = __webpack_require__(31776);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/QueryBuilder.js
var QueryBuilder = __webpack_require__(95692);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./src/qualification/context/index.tsx + 11 modules
var context = __webpack_require__(85643);
// EXTERNAL MODULE: ./src/qualification/schema/questions/customerTierQuestion.ts
var customerTierQuestion = __webpack_require__(30812);
// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/shared/components/EmbeddedFunnel/experiments/customer_tier/v1.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  svg {\n    font-size: ",
        "px;\n    background: #f0f0f0;\n    border-radius: 50%;\n    padding: 6px;\n  }\n  margin: ",
        ";\n  display: flex;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n  line-height: 27px;\n  margin-bottom: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  order: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 60%;\n  border-radius: 8px;\n  background: #f8f8f8;\n  padding: ",
        ";\n  order: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        "px;\n  font-weight: 700;\n  line-height: 34px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 500;\n  line-height: 17px;\n  letter-spacing: 0.4px;\n  margin: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline;\n  font-weight: 700;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline;\n  margin-left: ",
        "px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        "px;\n  margin: ",
        ";\n  padding: ",
        ";\n  .MuiButtonBase-root {\n    padding: 0;\n  }\n  svg {\n    font-size: 27px;\n    color: #3c4340;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}











function CustomerTier() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,context/* useQualification */._8)(), _actions = ref.actions, answerQuestion = _actions.answerQuestion, addRareCustomerTierStep = _actions.addRareCustomerTierStep, removeRareCustomerTierStep = _actions.removeRareCustomerTierStep, state = ref.state;
    var ref1 = (0,react.useState)(state.qualification.answers.customer_tier), value = ref1[0], setValue = ref1[1];
    var mobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("xs");
    });
    var handleChange = function(event) {
        var tier = event.target.value;
        setValue(tier);
        if ([
            customerTierQuestion/* customerTier.rareV1 */.$X.rareV1,
            customerTierQuestion/* customerTier.rareV2 */.$X.rareV2
        ].includes(tier)) {
            addRareCustomerTierStep();
        } else {
            removeRareCustomerTierStep();
        }
        answerQuestion("customer_tier", tier);
    };
    var formOptions = [
        {
            title: "qualification:customerTier.form.options.rarely.title",
            subtitle: "qualification:customerTier.form.options.rarely.subtext",
            value: (0,ablyft/* isVariationActive */.s_)(ablyft/* EXPERIMENT.customerTierABC.variations.variationB */.Op.customerTierABC.variations.variationB) ? customerTierQuestion/* customerTier.rareV1 */.$X.rareV1 : customerTierQuestion/* customerTier.rareV2 */.$X.rareV2
        },
        {
            title: "qualification:customerTier.form.options.regularly.title",
            subtitle: "qualification:customerTier.form.options.regularly.subtext",
            value: customerTierQuestion/* customerTier.regular */.$X.regular
        },
        {
            title: "qualification:customerTier.form.options.frequently.title",
            subtitle: "qualification:customerTier.form.options.frequently.subtext",
            value: customerTierQuestion/* customerTier.frequent */.$X.frequent
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        size: 905,
        disableGutters: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
            style: {
                backgroundColor: "#FFF",
                borderRadius: "16px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoBox, {
                        item: true,
                        xs: 12,
                        sm: 5,
                        mobile: mobile,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoHeader, {
                                children: t("qualification:customerTier.benefits.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BenefitPointBox, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonOutline/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                        ml: 2,
                                        children: t("qualification:customerTier.benefits.personal")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BenefitPointBox, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StarBorder/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                        ml: 2,
                                        children: t("qualification:customerTier.benefits.premium")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BenefitPointBox, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SentimentSatisfied/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                        ml: 2,
                                        children: t("qualification:customerTier.benefits.satisfaction")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BenefitPointBox, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QueryBuilder/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                        ml: 2,
                                        children: t("qualification:customerTier.benefits.customisations")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormBox, {
                        item: true,
                        xs: 12,
                        sm: 7,
                        mobile: mobile,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: t("qualification:customerTier.form.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                my: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSubtitle, {
                                    variant: "caption",
                                    children: t("qualification:customerTier.form.subtitle")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup/* default */.Z, {
                                "aria-label": "gender",
                                name: "gender1",
                                value: value,
                                onChange: handleChange,
                                children: formOptions.map(function(param, index) {
                                    var title = param.title, subtitle = param.subtitle, optionValue = param.value;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFormControlLabel, {
                                        value: optionValue,
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                        active: value === optionValue,
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                                            ml: 1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelTitle, {
                                                    children: t(title)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelSubtext, {
                                                    variant: "caption",
                                                    children: t(subtitle)
                                                })
                                            ]
                                        })
                                    }, index);
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
var BenefitPointBox = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(4.5);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2, 0);
});
var InfoHeader = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var InfoBox = (0,styled_components_browser_esm["default"])(Grid/* default */.Z)(_templateObject2(), function(param) {
    var mobile = param.mobile, theme = param.theme;
    return mobile ? theme.spacing(2, 2) : theme.spacing(3, 7.5);
}, function(props) {
    return props.mobile ? "2" : "1";
});
var FormBox = (0,styled_components_browser_esm["default"])(Grid/* default */.Z)(_templateObject3(), function(param) {
    var mobile = param.mobile, theme = param.theme;
    return mobile ? theme.spacing(2, 2) : theme.spacing(3, 7.5);
}, function(props) {
    return props.mobile ? "1" : "2";
});
var Title = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.spacing(2.5);
});
var FormSubtitle = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.spacing(3, 0);
});
var LabelTitle = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject6());
var LabelSubtext = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
});
var StyledFormControlLabel = (0,styled_components_browser_esm["default"])(FormControlLabel/* default */.Z)(_templateObject8(), function(props) {
    return props.active ? " #9CBA6C" : "#E3E4E4";
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(1, 0);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0.5, 2);
});

;// CONCATENATED MODULE: ./src/shared/components/EmbeddedFunnel/experiments/customer_tier/CustomerTier.js




function CustomerTier_CustomerTier() {
    if ((0,ablyft/* isVariationActive */.s_)(ablyft/* EXPERIMENT.customerTierABC.variations.variationC */.Op.customerTierABC.variations.variationC)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerTier, {});
    if ((0,ablyft/* isVariationActive */.s_)(ablyft/* EXPERIMENT.customerTierABC.variations.variationB */.Op.customerTierABC.variations.variationB)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerTier, {});
    return null;
}


/***/ }),

/***/ 61692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CustomerRareTier; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/lib/ablyft/index.ts
var ablyft = __webpack_require__(49423);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/VerifiedUser.js
var VerifiedUser = __webpack_require__(77316);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/Trans.js + 1 modules
var Trans = __webpack_require__(59251);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./src/qualification/context/index.tsx + 11 modules
var context = __webpack_require__(85643);
// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/shared/components/EmbeddedFunnel/experiments/rare_tier/v1.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 47px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 9px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: ",
        "px;\n  margin-top: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        "px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: ",
        "px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: ",
        "px;\n  margin: ",
        "px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -55px;\n  left: 35%;\n  width: fit-content;\n  img {\n    border-radius: 50%;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 345px;\n  margin: auto;\n  margin-top: 55px;\n  text-align: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  svg {\n    font-size: 42px;\n    background: #f0f0f0;\n    border-radius: 50%;\n    padding: 10px;\n  }\n  display: flex;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  padding-bottom: 0;\n  width: 40%;\n  order: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 60%;\n  border-radius: ",
        "px;\n  background: #f8f8f8;\n  padding: ",
        ";\n  position: relative;\n  order: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}










function CustomerTierRare() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var mobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("xs");
    });
    var ref = (0,context/* useQualification */._8)(), nextStep = ref.actions.nextStep;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        size: 800,
        disableGutters: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
            style: {
                borderRadius: "16px",
                marginTop: "90px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoBox, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        mobile: mobile,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                                mb: 2,
                                children: t("qualification:rareCustomerTier.v1.benefits.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BenefitPointBox, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifiedUser/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                        ml: 2,
                                        mb: 2,
                                        children: t("qualification:rareCustomerTier.v1.benefits.first")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BenefitPointBox, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifiedUser/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                        ml: 2,
                                        mb: 2,
                                        children: t("qualification:rareCustomerTier.v1.benefits.second")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BenefitPointBox, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifiedUser/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                        ml: 2,
                                        mb: 2,
                                        children: t("qualification:rareCustomerTier.v1.benefits.third")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BenefitPointBox, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifiedUser/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                        ml: 2,
                                        mb: 2,
                                        children: t("qualification:rareCustomerTier.v1.benefits.fourth")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceBox, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        mobile: mobile,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBox, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    priority: true,
                                    alt: "Service",
                                    src: "/artifacts/images/heycater_service.jpeg",
                                    width: "130px",
                                    height: "130px",
                                    objectFit: "cover"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailedBox, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                                        pt: 3,
                                        children: t("qualification:rareCustomerTier.v1.service.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceSubtitle, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                                            t: t,
                                            i18nKey: "qualification:rareCustomerTier.v1.service.subtitle",
                                            components: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}, "strong")
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                        onClick: nextStep,
                                        children: t("qualification:rareCustomerTier.v1.service.button")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterBox, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                                            t: t,
                                            i18nKey: "qualification:rareCustomerTier.v1.service.footer",
                                            components: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}, "strong")
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
var StyledButton = (0,styled_components_browser_esm["default"])(esm.Button)(_templateObject());
var FooterBox = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(1);
});
var TitleTypography = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(5);
});
var ServiceSubtitle = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3);
});
var ImageBox = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject4());
var DetailedBox = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject5());
var BenefitPointBox = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject6());
var InfoBox = (0,styled_components_browser_esm["default"])(Grid/* default */.Z)(_templateObject7(), function(param) {
    var mobile = param.mobile, theme = param.theme;
    return mobile ? theme.spacing(2, 2) : theme.spacing(1.5, 7.5);
}, function(props) {
    return props.mobile ? "2" : "1";
});
var ServiceBox = (0,styled_components_browser_esm["default"])(Grid/* default */.Z)(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3, 7 / 5);
}, function(props) {
    return props.mobile ? "1" : "2";
});

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Check.js
var Check = __webpack_require__(43500);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./src/shared/helpers/urls.ts
var urls = __webpack_require__(6880);
;// CONCATENATED MODULE: ./src/shared/components/EmbeddedFunnel/experiments/rare_tier/v2.js

function v2_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #7d8f5c;\n"
    ]);
    v2_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function v2_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n  background: #f8f8f8;\n  height: 100%;\n"
    ]);
    v2_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function v2_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  margin: ",
        ";\n  text-align: center;\n"
    ]);
    v2_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function v2_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  letter-spacing: 0.4px;\n"
    ]);
    v2_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function v2_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 47px;\n"
    ]);
    v2_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function v2_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 9px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: ",
        "px;\n  margin-top: ",
        "px;\n"
    ]);
    v2_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function v2_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        "px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: ",
        "px;\n  text-align: center;\n"
    ]);
    v2_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function v2_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: ",
        "px;\n  margin: ",
        ";\n"
    ]);
    v2_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function v2_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -55px;\n  left: ",
        "%;\n  width: fit-content;\n"
    ]);
    v2_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -55px;\n  left: ",
        "%;\n  width: fit-content;\n  img {\n    border-radius: 50%;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 345px;\n  margin: auto;\n  margin-top: 85px;\n  text-align: center;\n  margin-bottom: ",
        "px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  svg {\n    font-size: 20px;\n  }\n  font-size: 10px;\n  display: flex;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  width: 50%;\n  position: relative;\n  max-width: 455px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 50%;\n  border-radius: ",
        "px;\n  background: #f8f8f8;\n  position: relative;\n  max-width: 455px;\n  margin-top: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}












function v2_CustomerTierRare() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var mobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("xs");
    });
    var ref = (0,context/* useQualification */._8)(), nextStep = ref.actions.nextStep;
    var navigateToMarketplace = function() {
        window.location = (0,urls/* marketplaceURL */.j5)("/catering");
        js_cookie_default().set("customer_tier", "rare-c-mp");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        size: 800,
        disableGutters: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
            style: {
                borderRadius: "16px",
                marginTop: "90px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_InfoBox, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        mobile: mobile,
                        mr: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBox, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MacImageBox, {
                                    mobile: mobile,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        priority: true,
                                        alt: "Mac",
                                        src: "/artifacts/images/macbook.png",
                                        width: "220px",
                                        height: "130px",
                                        objectFit: "cover"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(v2_DetailedBox, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_TitleTypography, {
                                            pt: 3,
                                            mb: 2,
                                            children: t("qualification:rareCustomerTier.v2.bookYourself.title")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SutitleTypography, {
                                            children: t("qualification:rareCustomerTier.v2.bookYourself.subtitle")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                                            my: 3,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(v2_BenefitPointBox, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCheck, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitTypography, {
                                                            ml: 2,
                                                            mb: 1,
                                                            children: t("qualification:rareCustomerTier.v2.bookYourself.bullets.first")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(v2_BenefitPointBox, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCheck, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitTypography, {
                                                            ml: 2,
                                                            mb: 1,
                                                            children: t("qualification:rareCustomerTier.v2.bookYourself.bullets.second")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(v2_BenefitPointBox, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCheck, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitTypography, {
                                                            ml: 2,
                                                            mb: 1,
                                                            children: t("qualification:rareCustomerTier.v2.bookYourself.bullets.third")
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_StyledButton, {
                                            onClick: navigateToMarketplace,
                                            children: t("qualification:rareCustomerTier.v2.bookYourself.button")
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_ServiceBox, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        mobile: mobile,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBox, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceImageBox, {
                                    mobile: mobile,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        priority: true,
                                        alt: "Service",
                                        src: "/artifacts/images/heycater_service.jpeg",
                                        width: "130px",
                                        height: "130px",
                                        objectFit: "cover"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(v2_DetailedBox, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_TitleTypography, {
                                            pt: 3,
                                            children: t("qualification:rareCustomerTier.v2.service.title")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_ServiceSubtitle, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                                                t: t,
                                                i18nKey: "qualification:rareCustomerTier.v2.service.subtitle",
                                                components: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}, "strong")
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                                            my: 3,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(v2_BenefitPointBox, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCheck, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitTypography, {
                                                            ml: 2,
                                                            mb: 1,
                                                            children: t("qualification:rareCustomerTier.v2.service.bullets.first")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(v2_BenefitPointBox, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCheck, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitTypography, {
                                                            ml: 2,
                                                            mb: 1,
                                                            children: t("qualification:rareCustomerTier.v2.service.bullets.second")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(v2_BenefitPointBox, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCheck, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitTypography, {
                                                            ml: 2,
                                                            mb: 1,
                                                            children: t("qualification:rareCustomerTier.v2.service.bullets.third")
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_StyledButton, {
                                            onClick: nextStep,
                                            children: t("qualification:rareCustomerTier.v2.service.button")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_FooterBox, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                                                t: t,
                                                i18nKey: "qualification:rareCustomerTier.v2.service.footer",
                                                components: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}, "strong")
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
var StyledCheck = (0,styled_components_browser_esm["default"])(Check/* default */.Z)(v2_templateObject());
var CardBox = (0,styled_components_browser_esm["default"])(esm.Box)(v2_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(0, 1);
});
var SutitleTypography = (0,styled_components_browser_esm["default"])(esm.Typography)(v2_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.spacing(3, 0);
});
var BenefitTypography = (0,styled_components_browser_esm["default"])(esm.Typography)(v2_templateObject3());
var v2_StyledButton = (0,styled_components_browser_esm["default"])(esm.Button)(v2_templateObject4());
var v2_FooterBox = (0,styled_components_browser_esm["default"])(esm.Box)(v2_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(1);
});
var v2_TitleTypography = (0,styled_components_browser_esm["default"])(esm.Box)(v2_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(5);
});
var v2_ServiceSubtitle = (0,styled_components_browser_esm["default"])(esm.Typography)(v2_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3, 0);
});
var MacImageBox = (0,styled_components_browser_esm["default"])(esm.Box)(v2_templateObject8(), function(props) {
    return props.mobile ? "22" : "26";
});
var SourceImageBox = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject9(), function(props) {
    return props.mobile ? "33" : "36";
});
var v2_DetailedBox = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject10(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var v2_BenefitPointBox = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject11());
var v2_InfoBox = (0,styled_components_browser_esm["default"])(Grid/* default */.Z)(_templateObject12());
var v2_ServiceBox = (0,styled_components_browser_esm["default"])(Grid/* default */.Z)(_templateObject13(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
}, function(props) {
    return props.mobile ? "80px" : "auto";
});

;// CONCATENATED MODULE: ./src/shared/components/EmbeddedFunnel/experiments/rare_tier/CustomerRareTier.js





function CustomerRareTier() {
    if ((0,ablyft/* isVariationActive */.s_)(ablyft/* EXPERIMENT.customerTierABC.variations.variationB */.Op.customerTierABC.variations.variationB)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerTierRare, {});
    if ((0,ablyft/* isVariationActive */.s_)(ablyft/* EXPERIMENT.customerTierABC.variations.variationC */.Op.customerTierABC.variations.variationC)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_CustomerTierRare, {});
    return null;
}


/***/ }),

/***/ 26403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useInputFocusOnMount; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useInputFocusOnMount() {
    var shouldFocus = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        shouldFocus: true
    }).shouldFocus;
    var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (shouldFocus) {
            var ref;
            (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        }
    }, [
        shouldFocus
    ]);
    return {
        inputRef: inputRef
    };
}


/***/ }),

/***/ 25734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useLocalizedFieldName; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var shared_helpers_localizedFieldNames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53279);


function useLocalizedFieldName() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var localizedFieldAlgolia = (0,shared_helpers_localizedFieldNames__WEBPACK_IMPORTED_MODULE_1__/* .algoliaAttributeNameForLocale */ .u)(router.locale);
    var localizedAttributeName = (0,shared_helpers_localizedFieldNames__WEBPACK_IMPORTED_MODULE_1__/* .attributeNameForLocale */ .q)(router.locale);
    return {
        localizedFieldAlgolia: localizedFieldAlgolia,
        localizedAttributeName: localizedAttributeName
    };
}


/***/ }),

/***/ 87733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports StepperInput, StepperIconButton */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38799);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_icons_AddOutlined__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3550);
/* harmony import */ var _material_ui_icons_RemoveOutlined__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64824);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57833);
/* harmony import */ var shared_hooks_useCurrencySymbol__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11162);
/* harmony import */ var shared_hooks_useInputFocusOnMount__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26403);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        border-color: #e86202;\n        &:hover,\n        &:focus,\n        &:active {\n          border-color: #e86202;\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .MuiInputBase-input {\n    text-align: center;\n    background-color: ",
        ";\n    border: 1px solid transparent;\n    border-radius: ",
        "px;\n    height: 49px;\n    width: 110px;\n    box-sizing: border-box;\n\n    &:hover {\n      border-color: ",
        ";\n    }\n\n    &:focus,\n    &:active {\n      border-color: ",
        ";\n    }\n\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  border-radius: ",
        "px;\n  height: 49px;\n  width: 49px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  touch-action: manipulation;\n\n  &:hover {\n    background-color: ",
        ";\n  }\n\n  .MuiSvgIcon-root {\n    font-size: 18px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: ",
        "px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-right: ",
        "px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  right: ",
        "px;\n  top: 50%;\n  transform: translateY(-50%);\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}










function PriceStepperField(param) {
    var name = param.name, min = param.min, id = param.id, error = param.error, value = param.value, onChange = param.onChange, placeholder = param.placeholder, autoFocus = param.autoFocus;
    var inputRef = (0,shared_hooks_useInputFocusOnMount__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        shouldFocus: !!autoFocus
    }).inputRef;
    var minValue = min || 0;
    var currencySymbol = (0,shared_hooks_useCurrencySymbol__WEBPACK_IMPORTED_MODULE_4__/* .useCurrencySymbol */ .m)();
    var isInputValid = function(value) {
        var nextValue = Number(value);
        if (isNaN(nextValue)) {
            return false;
        }
        if (nextValue < minValue) {
            return false;
        }
        return true;
    };
    var handleChange = function(event) {
        var nextValue = Number(event.target.value);
        if (isInputValid(nextValue)) {
            onChange(nextValue);
        }
    };
    var onDecrement = function() {
        isInputValid(value - 1) && onChange(value - 1);
    };
    var onIncrement = function() {
        isInputValid(value + 1) && onChange(value + 1);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconButtonLeft, {
                onClick: onDecrement,
                id: "".concat(id, "-decrement"),
                "aria-label": "Minus",
                role: "button",
                disabled: value <= minValue,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_RemoveOutlined__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(InputWithAdornment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StepperInput, {
                        inputRef: inputRef,
                        name: name,
                        id: id,
                        error: !!error,
                        disableUnderline: true,
                        placeholder: placeholder,
                        type: "tel",
                        onChange: handleChange,
                        value: Number(value),
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Adornment, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Typography, {
                            children: currencySymbol
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconButtonRight, {
                onClick: onIncrement,
                id: "".concat(id, "-increment"),
                "aria-label": "Plus",
                role: "button",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_AddOutlined__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
            })
        ]
    });
}
var StepperInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_templateObject1(), function(props) {
    return props.theme.palette.text.disabled;
}, function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.palette.grey[400];
}, function(props) {
    return props.theme.palette.grey[500];
}, function(param) {
    var error = param.error;
    return !!error && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject());
});
var StepperIconButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_templateObject2(), function(props) {
    return props.theme.palette.grey[200];
}, function(props) {
    return props.theme.palette.grey[600];
}, function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.palette.grey[300];
});
var IconButtonRight = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(StepperIconButton)(_templateObject3(), function(props) {
    return props.theme.spacing(2);
});
var IconButtonLeft = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(StepperIconButton)(_templateObject4(), function(props) {
    return props.theme.spacing(2);
});
var InputWithAdornment = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div(_templateObject5());
var Adornment = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div(_templateObject6(), function(props) {
    return props.theme.spacing(2);
});
/* harmony default export */ __webpack_exports__["ZP"] = (PriceStepperField);


/***/ }),

/***/ 84561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports StepperInput, StepperIconButton */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(38799);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_icons_AddOutlined__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3550);
/* harmony import */ var _material_ui_icons_RemoveOutlined__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64824);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57833);
/* harmony import */ var shared_hooks_useInputFocusOnMount__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26403);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        border-color: #e86202;\n        &:hover,\n        &:focus,\n        &:active {\n          border-color: #e86202;\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .MuiInputBase-input {\n    text-align: center;\n    background-color: ",
        ";\n    border: 1px solid transparent;\n    border-radius: ",
        "px;\n    height: 49px;\n    width: 110px;\n    box-sizing: border-box;\n\n    &:hover {\n      border-color: ",
        ";\n    }\n\n    &:focus,\n    &:active {\n      border-color: ",
        ";\n    }\n\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  border-radius: ",
        "px;\n  height: 49px;\n  width: 49px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  touch-action: manipulation;\n\n  &:hover,\n  &:focus {\n    background-color: ",
        ";\n  }\n\n  &:active {\n    background-color: ",
        ";\n  }\n  .MuiSvgIcon-root {\n    font-size: 18px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: ",
        "px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-right: ",
        "px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








var QuantityStepperField = function(param) {
    var name = param.name, id = param.id, value = param.value, defaultValue = param.defaultValue, onChange = param.onChange, error = param.error, placeholder = param.placeholder, _autoFocus = param.autoFocus, autoFocus = _autoFocus === void 0 ? true : _autoFocus;
    var inputRef = (0,shared_hooks_useInputFocusOnMount__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        shouldFocus: autoFocus
    }).inputRef;
    var handleChange = function(nextValue) {
        onChange(Number(nextValue));
    };
    var onDecrement = function() {
        handleChange((value !== null && value !== void 0 ? value : 0) - 1);
    };
    var onIncrement = function() {
        handleChange((value !== null && value !== void 0 ? value : 0) + 1);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconButtonLeft, {
                onClick: onDecrement,
                id: "".concat(id, "-decrement"),
                "aria-label": "Minus",
                role: "button",
                disabled: !value,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_RemoveOutlined__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StepperInput, {
                inputRef: inputRef,
                name: name,
                disableUnderline: true,
                error: error,
                placeholder: placeholder,
                type: "tel",
                defaultValue: defaultValue,
                onChange: function(event) {
                    return handleChange(event.target.value);
                },
                value: value,
                autoComplete: "off"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconButtonRight, {
                onClick: onIncrement,
                id: "".concat(id, "-increment"),
                "aria-label": "Plus",
                role: "button",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_AddOutlined__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
            })
        ]
    });
};
var StepperInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_templateObject1(), function(props) {
    return props.theme.palette.text.disabled;
}, function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.palette.grey[400];
}, function(props) {
    return props.theme.palette.grey[500];
}, function(param) {
    var error = param.error;
    return !!error && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject());
});
var StepperIconButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_templateObject2(), function(props) {
    return props.theme.palette.grey[200];
}, function(props) {
    return props.theme.palette.grey[600];
}, function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.palette.grey[300];
}, function(props) {
    return props.theme.palette.grey[400];
});
var IconButtonRight = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(StepperIconButton)(_templateObject3(), function(props) {
    return props.theme.spacing(1);
});
var IconButtonLeft = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(StepperIconButton)(_templateObject4(), function(props) {
    return props.theme.spacing(1);
});
/* harmony default export */ __webpack_exports__["ZP"] = (QuantityStepperField);


/***/ })

}]);